import React from 'react';
import './segmented.css';

export interface SegmentedOption<T extends string = string> {
  label: string;
  value: T;
}

interface SegmentedControlProps<T extends string = string> {
  options: SegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
  size?: 'sm' | 'md';
  ariaLabel?: string;
}

function SegmentedControl<T extends string = string>({ options, value, onChange, size = 'md', ariaLabel }: SegmentedControlProps<T>) {
  return (
    <div className={`ui-segmented ${size}`} role="group" aria-label={ariaLabel || 'Segmented control'}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`ui-segmented__btn ${value === opt.value ? 'is-active' : ''}`}
          aria-pressed={value === opt.value}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default SegmentedControl;


